import { render, staticRenderFns } from "./ListMedia.vue?vue&type=template&id=22abdd66&scoped=true"
import script from "./ListMedia.vue?vue&type=script&lang=js"
export * from "./ListMedia.vue?vue&type=script&lang=js"
import style0 from "./ListMedia.vue?vue&type=style&index=0&id=22abdd66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22abdd66",
  null
  
)

export default component.exports